






























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import IInbound from '@/store/models/IInbound';
import IOutbound from '@/store/models/IOutbound';
@Component({
    components: {
        Snackbar
    }
})
export default class DashboardCalendar extends Vue {
    @Prop({ type: Array, required: true })
    InboundsList !: IInbound[];
    @Prop({ type: Array, required: true })
    OutboundsList !: IOutbound[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    type: string = "month";
    value: string = '';
    events: any[] = [];
    mode: string = "stack";
    weekday: any = [1, 2, 3, 4, 5, 6, 0];
    colors: any = ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'];
    names: any = ['Inbound', 'Outbound'];

    @Watch('InboundsList')
    onChangeInboundsList() {
        this.getEvents();
    }

    @Watch('OutboundsList')
    onChangeOutboundsList() {
        this.getEvents();
    }

    getEvents () {
        const events = [];
        for (let i = 0; i < this.InboundsList.length; i++) {
            const allDay = false;
            const first = new Date(this.InboundsList[i].dateIn);
            const second = new Date(this.InboundsList[i].dateIn);

            events.push({
                name: 'Inbound' + this.InboundsList[i].code,
                start: first,
                end: second,
                color: 'deep-purple',
                timed: !allDay
            });
        }
        for (let i = 0; i < this.OutboundsList.length; i++) {
            const allDay = false;
            const first = new Date(this.OutboundsList[i].dateOut);
            const second = new Date(this.OutboundsList[i].dateOut);

            events.push({
                name: 'Outbound' + this.OutboundsList[i].code,
                start: first,
                end: second,
                color: 'green',
                timed: !allDay
            });
        }
        
        this.events = events;
    }

    getEventColor (event: any) {
        return event.color;
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
